export enum CustomerPersonTypes {
  Natural = 'NATURAL',
  Legal = 'LEGAL',
}
